export default __webpack_public_path__ + "static/media/cb-2-generic-score-cover.4a9892bd.png";